module.exports = __webpack_public_path__ + "static/media/acro-acro-pose-acro-yoga.d3b66a56.png";